<template>
  <div class="twitter-content">
    <div class="container">
      <div class="col-sm-6 col-12 col-md-12" v-if="!loading" v-for="data in APIObj">
        <div class="card row">
          <div class="">
            <div class="col-md-2 col-sm-2 col-xs-12 img-alignment">
              <img :src="data.user.profile_image_url" class="img-responsive center-block">
            </div>
            <div class="col-md-10 col-sm-10 col-xs-12 align-vertical">
              <div
                class="col-md-4 col-sm-4 col-xs-4 break-res"
                data-toggle="tooltip"
                data-placement="center"
                :title="data.user.name"
              >{{data.user.name}}</div>
              <div
                class="col-md-4 col-sm-4 col-xs-4 break-res"
                data-toggle="tooltip"
                data-placement="center"
                :title="data.user.screen_name"
              >{{data.user.screen_name}}</div>
              <div
                data-toggle="tooltip"
                data-placement="center"
                :title="data.created_at"
                class="col-md-4 col-sm-4 col-xs-4 break-res"
              >{{data.created_at}}</div>
              <div class="top col-md-12 col-xs-12 col-sm-12">
                <b>{{data.user.description}}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loading">
        <i class="fa fa-circle-o-notch fa-spin twitter-loader"></i>
        <p>Loading Contens</p>
      </div>
      <div v-if="noRecords == 'no-record'">
        <img class="no-record" src="../assets/no-record.png">
        <p>No records Found</p>
      </div>
    </div>
    <div class="container">
      <div id="footer">
        <span class="footer-block make-left">© Design copyrights by Sathish</span>
        <br>
        <span>
          <a class="make-right" target="_blank" href="https://twitter.com">Twitter.com</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from "../services/DataService";
export default {
  name: "twitter-content",
  components: {},
  props: {
    msg: {
      type: String
    }
  },
  data() {
    return {
      totalcards: "",
      APIObj: "",
      noRecords: "",
      loading: false
    };
  },
  mounted: function() {
    this.$root.$on("searchData", data => {
      this.APIObj = data;
      this.noRecords = this.APIObj.length == 0 ? "no-record" : "";
    });
  },
  methods: {
    refreshCards: function() {
      setInterval(() => {
        this.loading = true;
        this.noRecords = ""
        this.$root.$emit("countReset", true);
        DataService.get("")
          .then(response => {
            this.APIObj = response;
            this.loading = false;
          })
          .catch(error => {
            console.error(error);
          });
      }, 30000);
    }
  },
  created: function() {
    this.loading = true;
    DataService.get("")
      .then(response => {
        this.APIObj = response;
        this.loading = false;
        this.$root.$emit("startCounting", true);
        this.refreshCards();
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>

<style>
.no-record {
  width: 120px;
  object-fit: contain;
}

.no-record + p {
  font-weight: bold;
  margin-top: 10px;
}

.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 100%;
  min-height: 110px;
  border-radius: 5px;
  margin-top: 20px;
  margin-left: 0px !important;
  margin-right: 0px !important; 
}

@media (max-width: 767px) {
  .card .img-responsive {
    background: #e0e0e0;
    width: 100%;
    height: 100px;
    padding: 13px;
    object-fit: contain;
  }
  .img-alignment{
    padding: 0px !important;
  }
}


.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.top {
  padding-top: 15px;
  height: 78px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
}

#footer {
  border-top: 2px solid #1da1f2;
  height: 60px;
  padding-top: 5px;
  margin-top: 50px;
}

.footer-block {
  margin: 20px 0;
}

.total-cards {
  max-width: 900px;
  margin: 0 auto;
}

.align-vertical {
  padding-top: 15px;
}

.break-res {
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  height: 1.3em;
  white-space: nowrap;
  cursor: pointer;
}

.img-responsive {
  height: 60px;
  width: 60px;
  border-radius: 7px;
  object-fit: cover;
}

.twitter-loader{
  font-size: 35px;
  color: #1da1f2;
}

.twitter-loader+p{
  font-weight: bold;
  margin-top: 10px;  
}

@media (min-width: 768px) {
  .img-alignment {
    padding: 25px 5px;
  }
}

@media (width: 768px) {
  .card .row {
    margin: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/TwitterContent.vue